export default __webpack_public_path__ + "static/media/426.f22106ab.gif";